import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class DanoneDnProductFamilyProduct extends BaseEntity {

  danoneDnProductFamilyCode : string;
  product                   : Product = new Product();
  rank                      : number;
  
  constructor() {
    super();

  }
}

	
